module.exports = __webpack_public_path__ + "static/img/puji1.e12170fa.png";